import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServiceServicePackChecklistEditor.html?raw';
import lang from 'dojo/_base/lang';

import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import _GlobalSelectEntityDialogsMixin from '../../../../moreCore/UI/Container/uiFrame';
import MainCatalogSelectV2 from '../../MainCatalogSelectV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../../_loadingHelpers/MainCatalogTypes";

class ServiceServicePackChecklistEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    selectContainer: HTMLDivElement;
    serviceChecklistSelect: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;

    //private isAllowButtons: boolean = false;

    setup(data: MainCatalogTypes.ServiceServicePackChecklist): void {
        this.setData(data);
        this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm));
        let heading = data.$Displayname;
        this.show("dlg", heading);
        this.setStartupState("ready");
    }

    private _onChangeSelect(): void {
        var value = this.serviceChecklistSelect.getValue();
        this.setAttributeValue("ref_service_checklist", value, true);
    }

    _onClickConfirm(e): void {
        this.emit("confirmed", this.getCurrentData());
        this.close();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServiceServicePackChecklistEditor);